import * as React from 'react';
import anytimepickup from 'src/assets/icons/anytimepickup.svg';
import freeins from 'src/assets/icons/freeins.svg';
import helpitems from 'src/assets/icons/helpitems.svg';
import styled from 'styled-components';
import {
  PersonTextContainer,
  PersonApartmentInfoContainer,
  PersonApartmentInfoText,
  PersonNameText,
  PerksContainer,
  PerkImage,
  PerkItem,
} from 'src/components/MatchComponents/PersonDetails';
import { coordinate, haversineDistance } from 'src/helpers/map_helpers';

const PersonDetailRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;

  width: 100%;

  padding-left: 45px;
  padding-right: 45px;
  padding-top: 34px;
`;

// @ts-ignore
const Portrait = styled.img`
  width: 44px;
  height: 44px;
  border-radius: 22px;
  background: black;
`;

interface props {
  style?: React.CSSProperties;
  firstName: string;
  lastName: string;
  address: string;
  customerCoordinate: coordinate;
  listingCoordinate: coordinate;
  freeInsurance: boolean;
  helpItems: boolean;
  pickupAnytime: boolean;
  bioText: string | null;
}

const PersonDetailRow = (props: props) => {
  return (
    <PersonDetailRowContainer style={props.style}>
      <PersonTextContainer>
        <PersonNameText>
          {props.firstName} {props.lastName} <br />
          <span>{props.bioText}</span>
        </PersonNameText>
        <PersonApartmentInfoContainer style={{ marginTop: 4 }}>
          <PersonApartmentInfoText>
            {props.address} <br />{' '}
            {haversineDistance(props.customerCoordinate, props.listingCoordinate, true).toFixed(1)}{' '}
            miles away
          </PersonApartmentInfoText>
        </PersonApartmentInfoContainer>
      </PersonTextContainer>
      <PerksContainer>
        {props.freeInsurance && (
          <PerkItem>
            <PerkImage src={freeins} /> Money Back Guarantee
          </PerkItem>
        )}
        {props.helpItems && (
          <PerkItem>
            <PerkImage src={helpitems} />
            Free Insurance
          </PerkItem>
        )}
        {props.pickupAnytime && (
          <PerkItem>
            <PerkImage src={anytimepickup} />
            Pickup Anytime
          </PerkItem>
        )}
      </PerksContainer>
    </PersonDetailRowContainer>
  );
};

export default PersonDetailRow;



// WEBPACK FOOTER //
// ./src/pages/MatchPage/components/PersonDetailRow.tsx